import logo from './logo.svg';
import './App.scss';
import Navigation from './navigation/Navigation';
import { BrowserRouter } from 'react-router-dom';
import { VolumeProvider } from './contexts/VolumeContext';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VolumeProvider>
          <Navigation />
        </VolumeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
